import useAxios from '../../hooks/useAxios'
import useSiteData from '../../hooks/useSiteData'
import React from 'react'
import { useQuery } from 'react-query/react'
// import { graphql, useStaticQuery } from 'gatsby'

interface BannerData {
  banner_text: string
  banner_cta_text: string
  banner_cta_link: string
}

// interface BannerInitialData {
//   talentIncSiteBanner: BannerData
// }

const defaultBannerData = {
  banner_text: '',
  banner_cta_text: '',
  banner_cta_link: '',
}

export const BannerContext = React.createContext<BannerData>(defaultBannerData)

const BannerProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { site_id: siteId } = useSiteData()
  const axios = useAxios()
  // const { talentIncSiteBanner } = useStaticQuery<BannerInitialData>(
  //   graphql`
  //     query UseSiteBanner {
  //       talentIncSiteBanner {
  //         banner_cta_link
  //         banner_cta_text
  //         banner_text
  //       }
  //     }
  //   `
  // )

  const { data } = useQuery<BannerData>(
    'banner',
    async () => {
      const url = `/v2/sites/${siteId}/banner`

      return axios
        .get(url, {
          baseURL: `https://${
            process.env.GATSBY_TALENTINC_API_HOST ?? 'api.talentinc.com'
          }`,
        })
        .then((resp) => resp.data)
    },
    {
      initialData: defaultBannerData,
    }
  )

  return (
    <BannerContext.Provider value={data ?? defaultBannerData}>
      {children}
    </BannerContext.Provider>
  )
}

export default BannerProvider
